module.exports = __webpack_public_path__ + "static/media/search-light.09834704.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search-light.svg
// module id = 145
// module chunks = 0